import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-y border-gold/40 bg-ivory" data-id="element-41" data-mp="1nv1l2blse3ze">
      <div className="mx-auto max-w-3xl px-3 py-6 sm:px-6 sm:py-8" data-id="element-42" data-mp="2bl5mqdfeztnr">
        <Reveal className="text-center" data-id="element-43" data-mp="2fkw8g2q33jlf">
          <h2 id="faq" className="font-display text-lg font-black uppercase leading-tight text-navy sm:text-2xl lg:text-3xl" data-id="element-44" data-mp="2fo1x5guswjgm">
            Preguntas frecuentes
          </h2>
          <span aria-hidden="true" className="mx-auto mt-1.5 block h-0.5 w-12 rounded-full bg-gold" data-id="element-45" data-mp="26rawer5b0gfp" />
        </Reveal>

        <div className="mt-3 grid gap-1" data-id="element-46" data-mp="2zazvojwm4y2q">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="rounded-md border border-navy/10 bg-white" data-id="element-47" data-mp="1vneu8ncx2kax" data-mpi={i}>
                <h3 data-id="element-48" data-mp="25fuddnzy9exe">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left" data-id="element-49" data-mp="25gcjrdgbt9j1">
                    <span className="text-[0.78rem] font-bold text-navy sm:text-[0.85rem]" data-id="element-50" data-mp="2oegf953aja2d">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={16} className={`flex-shrink-0 text-navy transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-51" data-mp="2jgnamghmyo47" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-52" data-mp="2p5euc9cs7fof">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-53" data-mp="2u3gekxly1l1h">
                      <p className="px-3 pb-2.5 text-[0.74rem] leading-snug text-navy sm:text-[0.82rem]" data-id="element-54" data-mp="3d0hlwp2yzx8l">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}